<script lang="ts">
    export let value = false;
</script>
<div class="flex justify-center">
    <input type="checkbox" bind:checked={value} class="h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-600">
</div>

